import React, { Component } from "react";
import { graphql, compose } from "react-apollo";
import moment from "moment";
import {
  queryGetCustomerFromCase,
  queryGetLabelsByType,
  mutationAddLabelToCustomer,
  mutationDeleteLabelFromCustomer
} from "Apollo";
import { ShowNotice } from "Store";
import LabelList from "module-common/label-list/LabelList";

export default compose(
  graphql(queryGetCustomerFromCase, { name: "customer" }),
  graphql(queryGetLabelsByType, {
    name: "labelsData",
    options: { variables: { type: "CUSTOMER" } }
  }),
  graphql(mutationAddLabelToCustomer, { name: "mutateAdd" }),
  graphql(mutationDeleteLabelFromCustomer, { name: "mutateDelete" })
)(
  class LabelListCase extends Component {
    render() {
      const {
        labelsData: { getLabelTemplates: labelForPicker },
        customer: { getCustomerFromCase: customer },
        ...rest
      } = this.props;

      const pickers = [];
      if (labelForPicker) {
        for (const label of labelForPicker) {
          pickers.push({
            label: label.displayName,
            color: "#" + label.color,
            value: label
          });
        }
      }

      const labels = [];
      if (customer && customer.labels) {
        for (const label of customer.labels) {
          labels.push({
            label: label.labelTemplate.displayName,
            color: "#" + label.labelTemplate.color,
            value: label.labelTemplate
          });
        }
      }

      // sort by order and date
      labels.sort((a, b) => {
        if (a.value.order !== b.value.order) {
          return a.value.order > b.value.order;
        } else {
          return moment(a.value.dateCreated).isAfter(b.value.dateCreated);
        }
      });

      return (
        <LabelList
          labels={labels}
          pickers={pickers}
          onAdd={this.onAdd}
          onRemove={this.onRemove}
          {...rest}
        />
      );
    }

    onAdd = async label => {
      const {
        customer: { getCustomerFromCase: { id } },
        mutateAdd
      } = this.props;
      try {
        await mutateAdd({
          variables: {
            customerInput: { id: id },
            labels: [{ id: label.value.id }]
          },
          refetchQueries: ["getCustomerFromCase"]
        });
        ShowNotice("label-add-success");
      } catch (error) {
        ShowNotice("label-add-error");
        console.log(error);
      }
    };

    onRemove = async label => {
      const {
        customer: { getCustomerFromCase: { id } },
        mutateDelete
      } = this.props;
      try {
        await mutateDelete({
          variables: {
            customerInput: { id: id },
            labels: [{ id: label.value.id }]
          },
          refetchQueries: ["getCustomerFromCase"]
        });
        ShowNotice("label-delete-success");
      } catch (error) {
        ShowNotice("label-delete-error");
        console.log(error);
      }
    };
  }
);



// WEBPACK FOOTER //
// ./src/module-case-management/info-panel/LabelListCustomerWithQueryMutation.js